//#region libraries
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';

//redux
import { selectShowAllFlights, setShowAllFlights } from '_redux/slices/timeline/timeline-control';
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";
import { selectUsedTheme } from '_redux/slices/timeline/theme';

//bootstrap
import { Form } from 'react-bootstrap';

//#endregion
const AllFlightsSwitch = () => {

    const dispatch = useDispatch();
    const showAllFlights = useSelector(selectShowAllFlights);
    const dbUser = useSelector(selectFirebaseInfo);
    const usedTheme = useSelector(selectUsedTheme);

    useEffect(() => {
        if (dbUser?.details?.authority === "JER") {
            dispatch(setShowAllFlights(true));
        }
    }, [dbUser]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                    Show All Flights
                </span>
                <Form.Check
                    onClick={() => dispatch(setShowAllFlights(!showAllFlights))}
                    type="switch"
                    defaultChecked={showAllFlights}
                    disabled={dbUser?.details?.authority === 'JER'}
                    checked={showAllFlights}
                    value={showAllFlights}
                />
            </div>
            <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                Include all flights in the timeline job list, even flights with no pre planned passengers.
            </span>
        </div>
    );
};


export default AllFlightsSwitch